export default {
  parseToInt (key) {
    if (!key) {
      return 0
    }

    return parseInt(key.match(/\d+/g).join(''), 10)
  }
}
